import { RouterProvider } from "react-router-dom";

import { createRouter } from "./routes";
import { AppProvider } from "./main-provider";
import { InstallPrompt } from "../components/offline/pwa-install";
import { OfflineBanner } from "../components/offline/offline-banner";

const AppRouter = () => {
    const router = createRouter();

    return <RouterProvider router={router} />;
};

const App = () => {
    return (
        <AppProvider>
            <OfflineBanner />
            {/* <InstallPrompt /> */}
            <AppRouter />
        </AppProvider>
    );
};

export default App;
